module.exports = __webpack_public_path__ + "fonts/proximasoft-bold-webfont.a2779e1.woff";